import { Box, Button, Grid, Typography, TextField, Tooltip, Breadcrumbs, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HttpRequest } from "../HttpRequest";
import { ArrowBackIos, EditOutlined } from "@mui/icons-material";
import CustomInputLabel from "../common/CustomInputLabel";
import { SuccessAlert } from "../common/snackbar/success";
import { ErrorAlert } from "../common/snackbar/error";
import CustomTable from "../common/CustomTable";
import CustomSearchInput from "../common/CustomSearchInput";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

const deletePickupModal = {
  borderRadius: "10px", backgroundColor: "#fff", position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)', width: "400px", height: "130px", p: '61px 22px 165px 63px', border: '1px #707070', m: '55px 104px 6.5px 118px'
}
const PickupRegions = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [successShow, setSuccessShow] = useState({ state: false, message: "" })
  const [errorShow, setErrorShow] = useState({ state: false, message: "" })
  const [showAddPickupModal, setShowAddPickupModal] = useState(false);
  const [showEditPickupModal, setShowEditPickupModal] = useState(false)
  const [pickUpLocations, setPickUpLocations] = useState([])
  const [pickUp,setPickUp] = useState({});
  const [pickData, setPickData] = useState({
    locationName: "",
    locationDescription: "",
  });
  const [openDeletePickup, setOpenDeletePickup] = useState(false)
  const handleOpenDeletePickup = () => { setOpenDeletePickup(true) }
  const handleCloseDeleteShippingRegion = () => { setOpenDeletePickup(false) }

  const handleFormData = (e) => {
    const { name, value } = e.target
    setPickData({ ...pickData, [name]: value })
  }
  const handleRowClick = (event, params) => {
    event.stopPropagation();
    setPickData({
      locationName: params.row.locationName,
      locationDescription: params.row.locationDescription,
    })
    setPickUp(params.row);
    setShowEditPickupModal(true);
  }

  const columns = [
    {
      field: 'locationName', headerName: 'Pickup Name', flex: isMobile ? 1 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Pickup Name </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          <Grid container spacing={2}>
            <Grid item>
              {params.row.locationName}
            </Grid>
          </Grid>
        </Box>)
      }
    },
    {
      field: 'locationDescription', headerName: 'Description', flex: isMobile ? 1.5 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Description   </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          {params.row.locationDescription}
        </Box>)
      }
    },
    {
      field: 'action', headerName: 'Action', flex: isMobile ? 0.8 : 1,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Action  </Box>) },
      renderCell: (params) => {
        const onClickDelete = (event) => {
          event.stopPropagation();
          // setShippingRegion(params.row);
          // handleOpenDeleteShippingRegion(true);
        }
        return (
          <Box style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "13px" : "25px", fontWeight: "500", marginTop: isMobile ? '5px' : '0' }}>
            <Tooltip title="Edit">
            <EditOutlined onClick={(event)=>handleRowClick(event,params)} sx={{ color: '#032541', marginRight: '10px', fontSize: isMobile ? '18px' : 'inherit' }} />
            </Tooltip>
            <Tooltip title="Delete">
            <DeleteIcon onClick={onClickDelete} sx={{ color: '#DC3545', fontSize: isMobile ? '18px' : 'inherit' }} />
            </Tooltip>
          </Box>
        )
      }
    },
  ]

  const getPickUPLocation = () => {
    HttpRequest({
      method: 'GET',
      url: `/api/v1/ecommerce/get_pickup_locations`
    }).then((data) => {
      setPickUpLocations(data.response?.data)
    }).catch((error) => {
    });
  }

  useEffect(() => {
    getPickUPLocation()
  }, [])

  const handlePickSubmit = () => {
    if (!pickData.locationName) {
      setErrorShow({ state: true, message: "Location name is required" });
      return;
    }
    if (!pickData.locationDescription) {
      setErrorShow({ state: true, message: "Location description is required" });
      return;
    }
    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/add_pickpoint_locations`,
      body: pickData

    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Pickup added successfully" });
        setShowAddPickupModal(false)
        getPickUPLocation()
        setPickData({
          locationName: "",
          locationDescription: "",
        })
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error adding pickup" });
    })
  }
  const handlePickUpdateSubmit = () => {
    if (!pickData.locationName) {
      setErrorShow({ state: true, message: "Location name is required" });
      return;
    }
    if (!pickData.locationDescription) {
      setErrorShow({ state: true, message: "Location description is required" });
      return;
    }
   
    HttpRequest({
      method: 'POST',
      url: `/api/v1/ecommerce/edit_pickup_locations/${pickUp._id}`,
      body: pickData

    }).then((data) => {
      if (data?.status === 200) {
        setSuccessShow({ state: true, message: "Pickup updated successfully" });
        setShowEditPickupModal(false)
        getPickUPLocation()
        setPickData({
          locationName: "",
          locationDescription: "",
        })
      } else {
        setErrorShow({ state: true, message: data.response?.data?.message });
      }
    }).catch((error) => {
      setErrorShow({ state: true, message: "Error updating pickup" });
    })
  }
  const breadcrumbs = [
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem", ml: isMobile ? 0 : 3 }}>
          Dashboard
      </Typography>,
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem" }}>
          Delivery Methods
      </Typography>,
      <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
          Pickups
      </Typography>
    ];
  return (
    <Box sx={{ mt: { xs: "15%", sm: "4%" }, pr: { xs: 2, sm: "3.5%" }, width: { xs: "100vw", sm: "calc(100vw - 355px)" }, maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box", px: { xs: 2, sm: 0 }, ml: { xs: -3, sm: 0 } }}>      
      <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
      <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
        <Box sx={{ flexDirection: "column", flex: 1 }}>
          <Box mb={1.5}>
            {showAddPickupModal ? (
              <Box variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
                <ArrowBackIos sx={{ width: '25px', height: '35px', objectFit: 'contain'}} onClick={() => { setShowAddPickupModal(false) }} />
                <Typography sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>
                  Add Pickup
                </Typography>
              </Box>
            ) : showEditPickupModal ? (
              <Box variant="h4" sx={{ display: 'flex', alignItems: 'center' }}>
                <ArrowBackIos sx={{ width: '25px', height: '35px', objectFit: 'contain'}} onClick={() => { setShowEditPickupModal(false) }} />
                <Typography sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>
                  Edit Pickup
                </Typography>
              </Box>
            ) : (
              <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600" }}>
                Pickups
              </Typography>
            )}
          </Box>
          <Grid item sx={{ mt: 1, mb: { xs: 1, sm: 1 }, ml: { sm: -3 } }}>
            <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: { xs: "11px", sm: "13px" } }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
                {breadcrumbs}
            </Breadcrumbs>
          </Grid>
          <Box>
            <Typography variant="h4" sx={{ color: "#707070", fontSize: { xs: "12px", sm: "14px" }, fontStyle: "normal", fontWeight: "normal" }}   >
              View and manage your Pickups.
            </Typography>
          </Box>
        </Box>
        {showAddPickupModal || showEditPickupModal ? null :
          <Box sx={{ width: { xs: '100%', sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>
            <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setShowAddPickupModal(true)}>
              Add Pickup
            </Button>
          </Box>
        }
      </Box>
      
      {showAddPickupModal || showEditPickupModal ? null :
        <Box sx={{ display: 'flex', mt: 2 }}>
          <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
            <CustomSearchInput placeholder={"Search pickup name ...."} name="search" value={""} sx={{ width: { xs: '100%', sm: 'auto' } }} />
          </Box>
        </Box>
      }
      
      {showAddPickupModal ?
        <>
          <Box sx={{ width: { xs: "100%", sm: "500px" }, mt: 2 }}>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="Location  Name" placeholder="Enter Location Name " />
              <TextField label="Location Name" value={pickData?.locationName} name="locationName" onChange={handleFormData} placeholder="Nairobi - CBD" sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
            </Box>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <CustomInputLabel label="Description" placeholder="Enter  Description*" />
              <TextField name={"locationDescription"} value={pickData.locationDescription} onChange={handleFormData} placeholder={"Service Description"} variant="outlined" margin="dense" sx={{ marginBottom: 2, width: "100%" }} multiline minRows={2} size={isMobile ? "small" : "medium"}/>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "end", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
              <Button variant="contained" sx={{ backgroundColor: "#fff", color: "#dc3545", textTransform: "none", borderRadius: "5px", border: "1px solid #dc3545", padding: "10.4px 30px 9.6px 30px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#fff", color: "#dc3545" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setShowAddPickupModal(false)}>
                Cancel
              </Button>
              <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={handlePickSubmit}>
                Add Pickup
              </Button>
            </Box>
          </Box>
        </> : showEditPickupModal ?
          <>
            <Box sx={{ width: { xs: "100%", sm: "500px" }, mt: 2 }}>
              <Box sx={{ width: "100%", marginTop: "20px" }}>
                <CustomInputLabel label="Location  Name" placeholder="Enter Location Name " />
                <TextField label="Location Name" value={pickData?.locationName} name="locationName" onChange={handleFormData} placeholder="Nairobi - CBD" sx={{ width: "100%" }} size={isMobile ? "small" : "medium"}/>
              </Box>
              <Box sx={{ width: "100%", marginTop: "20px" }}>
                <CustomInputLabel label="Description" placeholder="Enter  Description*" />
                <TextField name={"locationDescription"} value={pickData.locationDescription} onChange={handleFormData} placeholder={"Service Description"} variant="outlined" margin="dense" sx={{ marginBottom: 2, width: "100%" }} multiline minRows={2} size={isMobile ? "small" : "medium"}/>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "flex-end", alignContent: "end", gap: 1, flexDirection: { xs: "column", sm: "row" } }}>
                <Button variant="contained" sx={{ backgroundColor: "#fff", color: "#dc3545", textTransform: "none", borderRadius: "5px", border: "1px solid #dc3545", padding: "10.4px 30px 9.6px 30px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#fff", color: "#dc3545" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => setShowEditPickupModal(false)}>
                  Cancel
                </Button>
                <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" }, width: { xs: '100%', sm: 'auto' }}} onClick={handlePickUpdateSubmit}>
                  Update
                </Button>
              </Box>
            </Box>
          </> :
          <Box sx={{ width: '100%', overflowX: 'auto', mt: 2 }}>
            <Box sx={{ minWidth: { xs: 800, sm: '100%' } }}>
            <CustomTable columns={columns} data={pickUpLocations} sx={{ '& .MuiTableCell-root': { fontSize: isMobile ? '11px' : '14px', padding: isMobile ? '8px' : '16px'} }}/>
            </Box>
          </Box>
      }
    </Box>
  )
}

export default PickupRegions